module.exports = __webpack_public_path__ + "static/media/Easy_Returns-512.e8a30764.png";